module.exports = __webpack_public_path__ + "media/categories/1049-cd042c8b.svg";